var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 28,
    viewBox: "0 0 56 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 55,
    height: 28,
    rx: 5,
    fill: "#5078C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 21.5C21.7083 21.5 21.3161 21.3369 20.99 21.0108C20.6639 20.6847 20.5006 20.2922 20.5 19.8333V8.16667C20.5 7.70833 20.6633 7.31611 20.99 6.99C21.3167 6.66389 21.7089 6.50056 22.1667 6.5H33.8333C34.2917 6.5 34.6842 6.66333 35.0108 6.99C35.3375 7.31667 35.5006 7.70889 35.5 8.16667V19.8333C35.5 20.2917 35.3369 20.6842 35.0108 21.0108C34.6847 21.3375 34.2922 21.5006 33.8333 21.5H22.1667ZM22.1667 19.8333H33.8333V8.16667H22.1667V19.8333ZM23.8333 18.1667H32.1667C32.3333 18.1667 32.4583 18.0903 32.5417 17.9375C32.625 17.7847 32.6111 17.6389 32.5 17.5L30.2083 14.4375C30.125 14.3264 30.0139 14.2708 29.875 14.2708C29.7361 14.2708 29.625 14.3264 29.5417 14.4375L27.375 17.3333L25.8333 15.2708C25.75 15.1597 25.6389 15.1042 25.5 15.1042C25.3611 15.1042 25.25 15.1597 25.1667 15.2708L23.5 17.5C23.3889 17.6389 23.375 17.7847 23.4583 17.9375C23.5417 18.0903 23.6667 18.1667 23.8333 18.1667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.f44027ebd851cae4aec6a97a63e8baa7.svg";
export { ForwardRef as ReactComponent };